export const PROJECT_TYPES = {
	PROCUREMENT: {
		label: 'Procurement',
		value: 'PROCUREMENT',
		sortOrder: 0,
	},
	WATERFALL: {
		label: 'Waterfall Tendering',
		value: 'WATERFALL',
		sortOrder: 1,
	},
	DEDICATED_LANE: {
		label: 'Dedicated Lane',
		value: 'DEDICATED_LANE',
		sortOrder: 2,
	},
};

export const DEFAULT_SYSTEM_GROUP_NAME = 'Ungrouped';
export const DEFAULT_SYSTEM_GROUP_DELAY = 30;

// "Workflow" spans Waterfall + Dedicated Lane. Carrier groups exist only for these.
export const WORKFLOW_PROJECT_TYPES = [
	PROJECT_TYPES.WATERFALL.value,
	PROJECT_TYPES.DEDICATED_LANE.value,
];

export const IS_WORKFLOW_PROJECT_TYPE = (type: string): boolean =>
	WORKFLOW_PROJECT_TYPES.includes(type);
